import { render, staticRenderFns } from "./UserBarchart.vue?vue&type=template&id=1363247b"
import script from "./UserBarchart.vue?vue&type=script&lang=js"
export * from "./UserBarchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports